import {
  Classify2LineIcon,
  DotGridLineIcon,
  EventIcon,
  HandHeartLineIcon,
  MortarboardLineIcon,
  type RadioChangeEvent,
  RadioPills,
  VideoLineIcon,
} from 'ui';
import type { ChannelEntityType } from '../../types';

export type ChannelEntityOption = 'community' | 'event' | 'giving' | 'program' | 'video';

type P = {
  onChange?: (value: RadioChangeEvent) => void;
  options: ChannelEntityOption[];
  value?: ChannelEntityType;
};

const EntityTypeRadioPills = ({ onChange, options, value }: P) => {
  const generatePills = () => {
    const pills = [];

    if (options.length > 1) {
      pills.push({
        icon: <DotGridLineIcon />,
        label: 'All',
        value: undefined,
      });
    }

    // TODO: It is weird that values in these objects must start uppercase, otherwise filters do not work
    if (options.includes('community')) {
      pills.push({
        icon: <Classify2LineIcon />,
        label: 'Communities',
        value: 'Community',
      });
    }

    if (options.includes('program')) {
      pills.push({
        icon: <MortarboardLineIcon />,
        label: 'Programs',
        value: 'Program',
      });
    }

    if (options.includes('event')) {
      pills.push({
        icon: <EventIcon />,
        label: 'Events',
        value: 'Event',
      });
    }

    if (options.includes('giving')) {
      pills.push({
        icon: <HandHeartLineIcon />,
        label: 'Giving',
        value: 'Giving',
      });
    }

    if (options.includes('video')) {
      pills.push({
        icon: <VideoLineIcon />,
        label: 'Videos',
        value: 'Video',
      });
    }

    return pills;
  };

  return <RadioPills items={generatePills()} onChange={onChange} value={value} />;
};

export default EntityTypeRadioPills;
